<template>
    <v-container>
        <branch-office-not-set-blocker />
        <v-layout align-start wrap >
            <v-flex xs12>
                <w-main-title
                        class="pb-0"
                        :title="clientsLabel"
                        :breadcrumbs="breadcrumbs"
                ></w-main-title>
            </v-flex>
<!--            <v-flex xs12 md6 px-1>
               <label-picker disable-creation type="client" @change="onLabelsChange"/>
            </v-flex>-->

        </v-layout>
        <v-layout wrap class="search-wrapper">
            <v-flex xs12 text-right px-1>
                <v-text-field
                   fillled
                    hide-details
                    label="Buscar"
                    placeholder="Escribe nombre, apellido, rut, email o teléfono..."
                    prepend-inner-icon="search"
                    @click:clear="search=''"
                    v-model="search"
                    clearable
                    height="42"

                />
            </v-flex>
        </v-layout>
        <provider-client-list
                @loading="loading = $event"
                :search="search"
                hide-local-search
                :labels="labels"
        />
    </v-container>
</template>
<script>

    import WMainTitle from '@/components/common/WMainTitle'
    import ProviderClientList from "../../components/client/ProviderClientList";
    import BranchOfficeNotSetBlocker from "../../components/providers/BranchOfficeNotSetBlocker";
    import {getLabel} from '../../utils/Institution'
    import LabelPicker from "@/components/common/LabelPicker";

    export default{
        components: {
          LabelPicker,
            BranchOfficeNotSetBlocker,
            ProviderClientList,
            WMainTitle
        },
        data(){
            return {
                search: '',
                labels: [],
                loading: true
            }
        },
        methods:{
           onLabelsChange(val){
               this.labels = val
           }
        },
        computed: {
            clientsLabel(){
                return getLabel('commons.client.plural')
            },
            breadcrumbs() {
                const vm = this
                return [
                    {
                        text: vm.clientsLabel,
                        disabled: true,
                        href: ''
                    },
                ]
            }
        }
    }
</script>

<style scoped>
    .search-wrapper{
        padding: 5px;
        position: sticky !important;
        top: 60px !important;
        z-index: 1;
        background-color: var(--v-secondary-card-base)
    }
</style>
